/**
 * @file Open overlay action
 * @author Tzi Yang Lum
*/
import * as tslib_1 from "tslib";
import { ActionBase } from '../action';
import * as moment from 'moment';
var OpenOverlayAction = /** @class */ (function (_super) {
    tslib_1.__extends(OpenOverlayAction, _super);
    /**
     * @param {OverlayService} overlayService
     * @param {string} icon
     * @param {string} labelKey
     */
    function OpenOverlayAction(overlayService, icon, labelKey) {
        var _this = _super.call(this, icon, labelKey) || this;
        _this.overlayService = overlayService;
        return _this;
    }
    /**
     * Execute the action
     * @param {ActionConfiguration} actionConfiguration The action configuration
     */
    OpenOverlayAction.prototype.do = function (input) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var overlayParams;
            return tslib_1.__generator(this, function (_a) {
                overlayParams = {
                    action: input.actionConfiguration,
                    entity: input.item
                };
                this.overlayService.createOverlay(overlayParams);
                return [2 /*return*/, Promise.resolve()];
            });
        });
    };
    OpenOverlayAction.prototype.isAllowed = function (entity, name) {
        if (name === 'open-overlay-undo') {
            var item = entity['Item'] || entity;
            // Item should be either an assignment or attendant, therefore the marketplace item is one of these two.
            if (item['Service']) {
                return item['Service']['Marketplace'];
            }
            else if (item['Deployment'] && item['Deployment']['Demand']) {
                return item['Deployment']['Demand']['Marketplace'];
            }
            return false;
        }
        return _super.prototype.isAllowed.call(this, entity);
    };
    OpenOverlayAction.prototype.isDisabled = function (entity, name, backendSettingsService, userService) {
        var marketPlace = ['open-overlay-demand', 'open-overlay-service'].includes(name);
        if (marketPlace) {
            if (!userService.resourceOid || backendSettingsService.publishedTill.isBefore(entity['Start'])) {
                return true;
            }
            var ownTask_1 = false;
            var openSlot_1 = false;
            var children = entity.entityType.shortName === 'Demand' ? 'Deployments' : 'Attendants';
            entity[children].forEach(function (child) {
                if (child['Resource_Oid'] === userService.resourceOid) {
                    ownTask_1 = true;
                }
                else if (!child['Resource_Oid']) {
                    openSlot_1 = true;
                }
            });
            return ownTask_1 || !openSlot_1;
        }
        var planMacroOrWorkslip = ['open-overlay-workslip', 'open-overlay-planmacro', 'batch-planmacro'].includes(name);
        if (planMacroOrWorkslip) {
            return false;
        }
        if (name === 'open-overlay-undo') {
            return moment().add(7, 'days').isAfter(moment(entity['Start']));
        }
        if (name === 'open-overlay-agenda') {
            return entity['Calendar_Oid'] == null;
        }
        if (name === 'split-availability') {
            return this.repeatIsBeforeSplitDate(entity, backendSettingsService);
        }
        return _super.prototype.isDisabled.call(this, entity, name, backendSettingsService, userService);
    };
    OpenOverlayAction.prototype.repeatIsBeforeSplitDate = function (item, backendSettingsService) {
        var repeat = item['RepeatPattern'];
        if (!repeat || repeat.Kind === 'ONCE' || repeat.entityAspect.entityState.isAddedModifiedOrDeleted()) {
            return true;
        }
        var start = item['Start'];
        var dateOfStart = new Date(start.getFullYear(), start.getMonth(), start.getDate());
        var availability = backendSettingsService.availabilityClosedTill;
        return !availability.isBefore(repeat.UntilDate) || !availability.isAfter(dateOfStart);
    };
    return OpenOverlayAction;
}(ActionBase));
export { OpenOverlayAction };
